import { render, staticRenderFns } from "./ngo-users.vue?vue&type=template&id=3f21dd6e&scoped=true&"
import script from "./ngo-users.vue?vue&type=script&lang=js&"
export * from "./ngo-users.vue?vue&type=script&lang=js&"
import style0 from "./ngo-users.vue?vue&type=style&index=0&id=3f21dd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f21dd6e",
  null
  
)

export default component.exports